<!-- 仓库主数据 -->
<template>
  <div class="store">
    <sirui-search
      ref="storeDataSearch"
      :query="query"
      :columns="searchFormColumns"
      @resetBtnClick="resetBtnClickHandler"
      @searchBtnClick="queryBtnClickHandler"
    ></sirui-search>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        height="400"
        :buttonList="menuButtonList"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'currentStatus'">{{
              getCurrentStatus(row.currentStatus)
            }}</template>
            <template v-else-if="item.field === 'isSpecial'">{{
              getIsSpecialStr(row.isSpecial)
            }}</template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import { searchColumns, defaultTableColumn } from './index.js';
  import storeMixin from './../storeMixin.js';
  export default {
    name: 'FirstLevelStore',
    mixins: [storeMixin],
    components: {
      SiruiSearch,
      SiruiTable,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        lang: (state) => state.lang.language,
      }),
      searchFormColumns() {
        return searchColumns(this);
      },
      storeType() {
        let list = this.$baseRequest.getDictListMapByType('storage_type');
        return list;
      },
    },
    mounted() {
      this.getTableData();
      this.getButtonList();
    },
    data() {
      return {
        loading: false,
        query: {
          storageCode: '',
          storageName: '',
          isSpecial: '',
          storageTypeCode: '',
          // storageType: '',
          storageCreatePersonNo: '',
          storageCompanyName: '',
          status: '',
          isReality: '',
        },
        idList: [],
        menuButtonList: [], // 表格功能按钮
        multipleSelection: [], // 表格被选中的行数据
        tableData: [], // 表格数据
        importUrl: '',
        importData: {},
        columnList: defaultTableColumn,
      };
    },
    methods: {
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          // this.getColumnInfo();
        });
      },
      //获取当前列
      // getColumnInfo() {
      //   this.getColumnList(defaultTableColumn).then((res) => {
      //     // TODO 需求确认是否要做隐藏列
      //     this.columnList = defaultTableColumn;
      //   });
      // },
      // 获取表格数据
      async getTableData() {
        this.loading = true;
        const params = {
          data: {
            level: 1,
            ...this.query,
            // storageCompanyCode: this.userInfo.companyCode,
            // storageDepartmentCode: this.userInfo.departmentCode,
          },
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
        };
        const { data } = await this.getStoreTable(params);
        this.loading = false;
        this.tableData = data.records;
        this.$refs.siruiTable.setPageTotal(data.total);
      },
      // 表格上面的按钮
      chooseClick(type) {
        if (type == 'add') {
          let path = {
            path: '/storeMasterData/addStore',
            name: 'addStore',
            meta: {
              keepAlive: true,
              title: '仓库一级新建',
            },
            query: {
              status: 'create',
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        } else if (type === 'export') {
          const idsExport = this.multipleSelection.map((item) => item.id);
          this.exportExcel({
            level: 1,
            idsExport,
            ...this.query,
          });
        } else if (type === 'forbid') {
          this._updateRowStatus('ZT04');
        } else if (type === 'enable') {
          this._updateRowStatus('ZT03', 'enable');
        } else if (type === 'reject') {
          this._updateRowStatus('ZT05');
        } else if (type === 'approval') {
          this._updateRowStatus('ZT03');
        }
      },

      // 列表双击
      dblclickEvent(value) {
        this._dblclickEvent(value.row.id, 'firstLevelDetail', value.row);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
